export default {
    browse: 'Browse',
    dragAndDrop: 'Drag and drop your file here or',
    noFileChosen: 'No file chosen',
};
